module.exports = __webpack_public_path__ + "static/media/GroupBackground.4fadab2d.svg";